












import Vue from "vue";

function hexToRgba(hex: string, opacity: number) {
  return (
    "rgba(" +
    parseInt("0x" + hex.slice(1, 3)) +
    "," +
    parseInt("0x" + hex.slice(3, 5)) +
    "," +
    parseInt("0x" + hex.slice(5, 7)) +
    "," +
    opacity +
    ")"
  );
}

export default Vue.extend({
  name: "InfoCard",
  props: {
    header: { type: String, default: "" },
    icon: { type: String, default: "" },
    color: { type: String, default: "#F0C000" },
    value: { type: [String, Number], default: 0 }
  },
  computed: {
    iconStyle() {
      return {
        color: this.color,
        background: hexToRgba(this.color, 0.2)
      };
    }
  }
});
